<template>
  <v-card variant="outlined" class="p-6 max-w-3xl" data-cy="custom-plan-card">
    <div class="flex items-baseline gap-3">
      <h4 class="m-0">Compensation plan</h4>
      <span class="font-medium">Custom</span>
    </div>
    <p class="mt-2 text-gray-600">
      Set up by LeanLaw for your firm. To change it, contact LeanLaw support.
    </p>

    <h5 class="mt-6 mb-2">How this plan works</h5>
    <p v-if="loading" class="text-gray-500">Loading…</p>
    <p v-else-if="!blocks.length" class="text-gray-500">
      The plan description isn't available right now. Contact LeanLaw support.
    </p>
    <!-- ll-standards-ignore LL091 -- static list, re-rendered whole on load -->
    <ul v-else class="list-disc pl-6 space-y-1.5">
      <li v-for="(block, i) in blocks" :key="i">
        <template v-for="(segment, j) in block.segments" :key="j">
          <strong v-if="segment.bold">{{ segment.text }}</strong>
          <span
            v-else-if="segment.code"
            class="inline-block rounded bg-gray-100 px-1.5 text-sm font-medium"
            >{{ segment.text }}</span
          >
          <template v-else>{{ segment.text }}</template>
        </template>
      </li>
    </ul>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useCompensationPlanStore } from '../stores/useCompensationPlanStore';
import { parsePlanDescription } from '../utils/planDescription';

const store = useCompensationPlanStore();
const { plan, loading } = storeToRefs(store);
const { handleError } = useSnackbarHandler();

const blocks = computed(() => parsePlanDescription(plan.value?.description));

onMounted(async () => {
  try {
    await store.loadPlan();
  } catch (error) {
    handleError(error);
  }
});
</script>
